<!--
 * @Date: 2023-08-25 17:16:44

-->
<template>
  <bk-view class="s-header" :class="{
    'view-profileAction': item.isFormstobecompleted
  }">
    <bk-view class="view-actionRequired-main">
      <bk-icon icon="icon-tishi"></bk-icon> 
      <bk-lang code="appointment_actionRequired"></bk-lang>
    </bk-view>
    <bk-view class="view-comp-main">
      <bk-icon icon="icon-mendian"></bk-icon>
      <bk-view class="view-compName"> {{ item.compName }}</bk-view>
    </bk-view>
  </bk-view>

  <!-- 团体预约 -->
  <template v-if="item.groupReserve===1 && item.groupReserveProjectList?.length">
    <bk-view class="view-customer-row"  v-for="customerItem in item.groupReserveProjectList" :key="customerItem.customerIndex">
      <bk-view class="view-title-main">
        <bk-lang code="res_add_groupReserve_customer"></bk-lang>
        <span>{{customerItem.customerName}}</span>
      </bk-view>
      <bk-view class="res-record-item" v-for="sItem in customerItem.reserveProjectList" :key="sItem.id">
        <bk-image :src="sItem.showCoverImg || $bk_getImageUrl('Def_Img_Service.png')"></bk-image>
        <bk-view class="view-rightInfo">
          <bk-title>{{ sItem.name }}</bk-title>
          <bk-view>
            <span v-if="sItem.reserveEmpStr && sItem.assign==1"><bk-lang code="reserve_with" /> {{ sItem.reserveEmpStr }}</span>
            <bk-lang v-else code="appointment_walk_in"></bk-lang>
            <span v-if="status !== 'upcoming'">
              <bk-date :curShop="sItem" showHm :date="sItem?.startDateTime?.showValue" showWeek></bk-date>
            </span>
          </bk-view>
        </bk-view>

        <bk-view class="date-view" v-if="status === 'upcoming'">
          <bk-image :src="dateImgUrl"></bk-image>
          <bk-date :curShop="sItem" showHm :date="sItem?.startDateTime?.showValue" showWeek></bk-date>
        </bk-view>
      </bk-view>
    </bk-view>
  </template>
  <bk-view v-else class="res-record-item" v-for="sItem in item.reserveProjectList" :key="sItem.id">
    <bk-image :src="sItem.showCoverImg || $bk_getImageUrl('Def_Img_Service.png')"></bk-image>
    <bk-view class="view-rightInfo">
      <bk-title>{{ sItem.name }}</bk-title>
      <bk-view>
        <span v-if="sItem.reserveEmpStr && sItem.assign==1"><bk-lang code="reserve_with" /> {{ sItem.reserveEmpStr }}</span>
        <bk-lang v-else code="appointment_walk_in"></bk-lang>
        <span v-if="status !== 'upcoming'">
          <bk-date :curShop="sItem" showHm :date="sItem?.startDateTime?.showValue" showWeek></bk-date>
        </span>
      </bk-view>
    </bk-view>
		
    <bk-view class="date-view" v-if="item.bizScene==='reserve' && status === 'upcoming'">
      <bk-image :src="dateImgUrl"></bk-image>
      <bk-date :curShop="sItem" showHm  :date="sItem?.startDateTime?.showValue" showWeek></bk-date>
    </bk-view>

		<div v-if="item.bizScene==='waiting'" class="view-preferredTime">
			<bk-image :src="dateImgUrl"></bk-image>
			<div class="view-date">
				<div class="view-date-item" v-for="(timeItem,timeIndex) in item.preferredTimeList" :key="timeIndex">
					<bk-date :curShop="sItem" :date="timeItem.preferredDate"></bk-date>
					<span class="view-timeInfo">
						<bk-date :curShop="sItem" :showYMD="false" fillHmsYMD showHm :date="timeItem.startTime"></bk-date>
						<span>&nbsp;-&nbsp;</span>
						<bk-date :curShop="sItem" :showYMD="false" fillHmsYMD showHm :date="timeItem.endTime"></bk-date>
					</span>
				</div>
			</div>
		</div>

  </bk-view>
</template>
  
<script>
	import dayjs from 'dayjs';
	import { dateMap } from '../../dataSource';
	import { customerReq } from '@/reqService';

	export default {
		name: 'ResRecordItem',
		props: {
			item: {
				type: Object,
				default: () => {
					return {};
				}
			},
			status: String
		},
		computed: {
			dateImgUrl (){
				let res = 'Def_Icon_Calendar_Clock.png'; 
				
				if(window.oblissDZFlag){
					res = 'Def_Icon_Calendar_Clock_Healthy.png'
				}

				if(window.komoDZFlag){
					res = 'Def_Icon_Calendar_Clock_Komo.png'
				}

				return this.$bk_getImageUrl(res);
			},
			resTime () {
				return (date) => {
					const _format = dateMap[this.languageType] || 'MM-DD-YYYY HH:mm';
					return dayjs(date).format(_format);
				};
			}
		},
		created (){

			if(this.item?.bizScene==='reserve'){
				setTimeout(() => {
					this.getTriggerScenarioProfile();
				}, 600);
			}
			
		},
		methods:{
			getTriggerItemList (){
				const { reserveProjectList=[] } = this.item || {};
				return reserveProjectList.map((item) => {
					return { goodsCode:item.code, goodsType: 2 };
				});
			},
			async getTriggerScenarioProfile (){
				let { item } = this;
				const { manualProfileList=[], delProfileIds=[], profile =[] } = item?.reserveRelated || {};
				let params = {
					compId: this.item.compId,
					triggerItemList: this.getTriggerItemList(),
					triggerType: 'BOOKING',
					relationId:this.item.id,
					memberId:this.item.memberId,
				};
				let res = await customerReq.requestPostProfileRelationList(this, params);

				res = (res || []).concat(manualProfileList).filter((item) => {
					return !delProfileIds.includes(item.id);
				});
        
				item.isFormstobecompleted = res.length && res.length !== profile?.length;
			},
		}
	};
</script>
  
<style lang='less' scoped>
@import './resRecordBase.less';
</style>